import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { Customer } from '../../../models';
import { Observable, Subject } from 'rxjs';
import { CustomerService } from '../../../shared';
import {
  debounceTime,
  filter,
  map,
  mergeMap,
  startWith,
  takeUntil
} from 'rxjs/operators';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomerNamePipe } from 'src/app/shared/pipes/customer-name.pipe';
import { CustomerAddressPipe } from 'src/app/shared/pipes/customer-address.pipe';
import { CustomerContactDetailsPipe } from 'src/app/shared/pipes/customer-contact-details.pipe';
import { MatFormField } from '@angular/material/form-field';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption
} from '@angular/material/autocomplete';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-merge-customer-dialog',
  templateUrl: './merge-customer-dialog.component.html',
  styleUrls: ['./merge-customer-dialog.component.css'],
  providers: [CustomerService],
  standalone: true,
  imports: [
    CustomerNamePipe,
    CustomerAddressPipe,
    CustomerContactDetailsPipe,
    MatFormField,
    ReactiveFormsModule,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatOption,
    MatIcon,
    MatInput,
    MatButton,
    NgIf,
    MatDialogModule,
    FlexModule,
    AsyncPipe,
    NgFor
  ]
})
export class MergeCustomerDialogComponent implements OnInit, OnDestroy {
  sourceCustomer: Customer;
  destinationCustomer: Customer;

  filteredCustomers$: Observable<Customer[]>;
  customerSearch = new UntypedFormControl();
  merging = false;
  private ngUnsubscribe = new Subject<void>();
  private ngUnsubscribe$ = this.ngUnsubscribe.asObservable();
  clearContentAfterSelect = () => '';

  constructor(
    public dialogRef: MatDialogRef<MergeCustomerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private customerService: CustomerService,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.sourceCustomer = data.customer;
  }

  ngOnInit() {
    this.updateFilteredCustomersOnType();
  }

  doMerge() {
    if (!this.destinationCustomer || this.merging) {
      return;
    }
    this.customerService
      .mergeCustomers(this.sourceCustomer.id, this.destinationCustomer.id)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => {
        this.toastr.info(
          'Redirecting to destination customer',
          'Customer Merged'
        );
        this.router.navigate(['customer', this.destinationCustomer.id]);
        this.dialogRef.close();
      });
  }

  private updateFilteredCustomersOnType() {
    this.filteredCustomers$ = this.customerSearch.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      filter((value) => value && typeof value === 'string'),
      mergeMap((searchTerm) => this.customerService.search(searchTerm)),
      map((customers) =>
        customers.filter((customer) => customer.id !== this.sourceCustomer.id)
      )
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
